export function urlEncodeB64(input: string) {
    return input.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
